var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7445 25.0654C22.4199 21.5227 19.0042 19.0003 14.9993 19.0003C10.9945 19.0003 7.57881 21.5227 6.25424 25.0654M23.7445 25.0654C26.5556 22.6209 28.3327 19.0181 28.3327 15.0003C28.3327 7.63653 22.3631 1.66699 14.9993 1.66699C7.63555 1.66699 1.66602 7.63653 1.66602 15.0003C1.66602 19.0181 3.44315 22.6209 6.25424 25.0654M23.7445 25.0654C21.4034 27.1012 18.3453 28.3337 14.9993 28.3337C11.6534 28.3337 8.59527 27.1012 6.25424 25.0654M18.9993 11.0003C18.9993 13.2095 17.2085 15.0003 14.9993 15.0003C12.7902 15.0003 10.9993 13.2095 10.9993 11.0003C10.9993 8.79119 12.7902 7.00033 14.9993 7.00033C17.2085 7.00033 18.9993 8.79119 18.9993 11.0003Z",
    stroke: "#DF2027",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.06bd668610dafa874de039accc01a8cb.svg";
export { ForwardRef as ReactComponent };